import { render } from "./About.vue?vue&type=template&id=216e2392&scoped=true&ts=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=216e2392&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216e2392"]])

export default __exports__